import React, { Component } from 'react'

// ui
import Modal from '../../components/feedback/modal'
import Button from '../../components/uielements/button'

// redux
import { connect } from 'react-redux'
import userActions from '../../redux/user/actions'

class ModalCofirmDelete extends Component {
    _handleOK = () => {
        this.props.dismiss()
        this.props.deleteUser(this.props.user.uid)
    }

    _handleCancel = () => {
        this.props.dismiss()
    }

    render() {
        const { visible } = this.props
        return (
            <Modal
                visible={visible}
                title="Xác nhận xoá người dùng"
                onOk={() => this._handleOK()}
                onCancel={() => this._handleCancel()}
                centered
                footer={[
                    <Button
                        key="back"
                        size="large"
                        type="primary"
                        onClick={() => this._handleCancel()}
                    >
                        Không
                    </Button>,
                    <Button
                        key="submit"
                        type="danger"
                        size="large"
                        // loading={this.state.loading}
                        onClick={() => this._handleOK()}
                    >
                        Xoá
                    </Button>,
                ]}
            >
                <p>Bạn có chắc chắn xoá người dùng này không?</p>
            </Modal>
        )
    }
}

const mapStateToProps = state => {
    return {
        user: state.user.currentUser,
        visible: state.user.modalConfirmDeletState,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dismiss: () => {
            dispatch(userActions.action.dismissModalConfirmDeleteUser())
        },
        deleteUser: userId => {
            dispatch(userActions.action.deleteUser(userId))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ModalCofirmDelete)
